module.exports = __webpack_public_path__ + "static/media/Ile_New-Logo_Web-02.25f8a2e3.jpg";